module.exports = __webpack_public_path__ + "img/safe.7f3de60e.svg";